import { getSiteIdsForGroups } from "@/utils/store";

const DEFAULT_STATE = {
  sites: [],
  siteGroups: [],

  // VisitorsData :
  dates: [],
  containsText: "",

  // Forecast :
  forecastDates: [],
  gamAdUnits: [],
  gamPlacements: [],
  gamTargetingPreset: null,
  gamPositions: [],
  gamDeviceCategories: [],
  permutiveCohorts: [],

  // Marmiton :
  searchType: "",
  searchColumn: "",

  // Video-Inventory:
  groupByMonth: false,
};

export default {
  namespaced: true,
  state: {
    ...DEFAULT_STATE,
  },
  getters: {
    getSites: (state) => state.sites,
    getSiteGroups: (state) => state.siteGroups,

    // VisitorsData :
    getContainsText: (state) => state.containsText,
    getDates: (state) => {
      // always return the dates ordered
      return state.dates[0] < state.dates[1]
        ? [state.dates[0], state.dates[1]]
        : [state.dates[1], state.dates[0]];
    },

    // Forecast :
    getForecastDates: (state) => {
      // always return the dates ordered
      return state.forecastDates[0] < state.forecastDates[1]
        ? [state.forecastDates[0], state.forecastDates[1]]
        : [state.forecastDates[1], state.forecastDates[0]];
    },
    getGamAdUnits: (state) => state.gamAdUnits,
    getGamPlacements: (state) => state.gamPlacements,
    getGamTargetingPreset: (state) => state.gamTargetingPreset,
    getGamPositions: (state) => state.gamPositions,
    getGamDeviceCategories: (state) => state.gamDeviceCategories,
    getPermutiveCohorts: (state) => state.permutiveCohorts,

    // Marmiton :
    getSearchType: (state) => state.searchType,
    getSearchColumn: (state) => state.searchColumn,

    // Video-Inventory:
    getGroupByMonth: (state) => state.groupByMonth,
  },
  mutations: {
    initState(state) {
      for (const [key, value] of Object.entries(DEFAULT_STATE)) {
        state[key] = value;
      }
    },
    setSites(state, payload) {
      state.sites = payload;
    },
    setSiteGroups(state, payload) {
      state.siteGroups = payload;
    },

    // VisitorsData :
    setContainsText(state, payload) {
      state.containsText = payload;
    },
    setDates(state, payload) {
      state.dates = payload;
    },

    // Forecast :
    setForecastDates(state, payload) {
      state.forecastDates = payload;
    },
    setGamAdUnits(state, payload) {
      state.gamAdUnits = payload;
    },
    setGamPlacements(state, payload) {
      state.gamPlacements = payload;
    },
    setGamTargetingPreset(state, payload) {
      state.gamTargetingPreset = payload;
    },
    setGamPositions(state, payload) {
      state.gamPositions = payload;
    },
    setGamDeviceCategories(state, payload) {
      state.gamDeviceCategories = payload;
    },
    setPermutiveCohorts(state, payload) {
      state.permutiveCohorts = payload;
    },

    // Marmiton :
    setSearchType(state, payload) {
      state.searchType = payload;
    },
    setSearchColumn(state, payload) {
      state.searchColumn = payload;
    },

    // Video-Inventory:
    setGroupByMonth(state, payload) {
      state.groupByMonth = payload;
    },
  },
  actions: {
    initState({ commit }) {
      commit("initState");
    },
    updateSites({ commit }, payload) {
      commit("setSites", payload);
    },
    async updateSiteGroups({ commit }, payload) {
      commit("setSiteGroups", payload);

      const site_ids = await getSiteIdsForGroups(payload);
      commit("setSites", site_ids);

      return site_ids;
    },

    // VisitorsData :
    updateDates({ commit }, payload) {
      if (payload.length >= 2) {
        commit("setDates", payload);
      }
    },
    updateContainsText({ commit }, payload) {
      commit("setContainsText", payload);
    },

    // Forecast :
    updateForecastDates({ commit }, payload) {
      if (payload.length >= 2) {
        commit("setForecastDates", payload);
      }
    },
    updateGamAdUnits({ commit }, payload) {
      commit("setGamAdUnits", payload);
    },
    updateGamPlacements({ commit }, payload) {
      commit("setGamPlacements", payload);
    },
    updateGamTargetingPreset({ commit }, payload) {
      commit("setGamTargetingPreset", payload);
    },
    updateGamPositions({ commit }, payload) {
      commit("setGamPositions", payload);
    },
    updateGamDeviceCategories({ commit }, payload) {
      commit("setGamDeviceCategories", payload);
    },
    updatePermutiveCohorts({ commit }, payload) {
      commit("setPermutiveCohorts", payload);
    },

    // Marmiton :
    updateSearchType({ commit }, payload) {
      commit("setSearchType", payload);
    },
    updateSearchColumn({ commit }, payload) {
      commit("setSearchColumn", payload);
    },

    // Video-Inventory:
    updateGroupByMonth({ commit }, payload) {
      commit("setGroupByMonth", payload);
    },
  },
};
